module.exports = __webpack_public_path__ + "static/img/home_bottom_02.6bf0308.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_bottom_02.jpg
// module id = N8Mi
// module chunks = 1